import { render, staticRenderFns } from "./moneyBoxesSummaryBox.vue?vue&type=template&id=4e835ecc&"
import script from "./moneyBoxesSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./moneyBoxesSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports